import { SkeletonBlock } from '~/shared/ui'
import { LoadingSkeleton as PatientsLoadingSkeleton } from './patients/loading-skeleton'

export function LoadingSkeleton() {
  return (
    <div className="flex h-full w-full overflow-hidden">
      <div className="border-divider flex h-full w-[360px] shrink-0 flex-col justify-between border-r">
        <div className="flex flex-col">
          <div className="border-action-hovered border-b px-6 pt-4 pb-2">
            <SkeletonBlock className="h-[28px]" />
            <div className="mt-3 flex flex-col gap-2">
              <SkeletonBlock className="h-5" />
              <SkeletonBlock className="h-5" />
            </div>
          </div>

          <div className="border-action-hovered border-b px-6 py-4">
            <div className="border-action-hovered flex flex-col gap-4 border-b pb-3">
              <SkeletonBlock className="h-5 w-[100px]" />
              <SkeletonBlock className="h-5" />
            </div>

            <div className="mt-4 flex flex-col gap-3">
              <SkeletonBlock className="h-4 w-[180px]" />
              <SkeletonBlock className="h-5" />
              <SkeletonBlock className="h-5" />
              <SkeletonBlock className="h-5" />
              <SkeletonBlock className="h-5" />
              <SkeletonBlock className="h-5" />
            </div>
          </div>
        </div>
      </div>

      <PatientsLoadingSkeleton />
    </div>
  )
}
